import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

const selectors = {
    slider: '[data-section-type="text-with-icons"] .text-with-icons__wrapper',
    sliderItem: '.text-with-icon-item'
}

jQuery(function() {
    if($(window).outerWidth() < 641 ) {
        if($(selectors.sliderItem).length > 2){
            const $carousel = $(selectors.slider);
            var flkty = new Flickity( selectors.slider, {
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                resize: false,
                watchCSS: false,
                draggable: true,
                fade: 'fade',
                cellAlign: 'left',
                adaptiveHeight: true,
                autoPlay: 4000,
                selectedAttraction: 0.2,
                friction: 0.8
            });
        }
    } else {
        if($(selectors.sliderItem).length > 3){
            const $carousel = $(selectors.slider);
            var flkty = new Flickity( selectors.slider, {
                pageDots: true,
                prevNextButtons: false,
                groupCells: 2,
                resize: true,
                draggable: true,
                fade: 'fade',
                cellAlign: 'left',
                adaptiveHeight: true,
                autoPlay: 4000,
                selectedAttraction: 0.2,
                friction: 0.8
            });
        }
    }
})
